import { forwardRef } from 'react';

import { Typography } from '@workspace/ui/components/Typography';
import { useBreakpoint } from '@workspace/ui/hooks/useBreakpoint';
import { cn } from '@workspace/ui/lib/utils';

import type { FooterProps } from './Footer.js';
import { useFooterSlots } from './useFooterSlots.js';

export const FooterBaseSaas = forwardRef<HTMLDivElement, FooterProps>(
  (
    {
      logo,
      logoWidth = 'w-78',
      name,
      compact = false,
      children,
      className,
      ...props
    },
    ref,
  ) => {
    const slots = useFooterSlots(children);
    const { isMobile } = useBreakpoint();

    if (isMobile) return null;

    const LogoDesktop = logo.desktop;

    return (
      <footer
        {...props}
        ref={ref}
        className={cn(
          'flex flex-col border-navigation-stroke-secondary border-t bg-navigation-bg px-15 pt-15 text-navigation-text-primary',
          'rounded-t-7',
          compact && 'pt-9',
          className,
        )}
      >
        {slots.topSection && <div className="flex">{slots.topSection}</div>}
        <div
          className={cn(
            'mt-10 grid grid-cols-[1fr_312px_1fr] items-center border-navigation-stroke-secondary border-t py-15',
            compact && 'mt-6 py-8',
          )}
        >
          {slots.socials}
          <div className={`flex justify-center align-center`}>
            {LogoDesktop && (
              <LogoDesktop
                aria-label="logo"
                className={cn(
                  'h-[46px] text-graphic-regular-brand',
                  compact && 'h-[34px]',
                )}
              />
            )}
          </div>
          <div className="flex items-center justify-end gap-4">
            <Typography.Text100RegularHigh className="text-end">
              © {new Date().getFullYear()} {name} All rights reserved.
            </Typography.Text100RegularHigh>
            {slots.languagePicker}
          </div>
        </div>
      </footer>
    );
  },
);
FooterBaseSaas.displayName = 'FooterBaseSaas';
